import React, { useState } from 'react';
import logo from '../logo.svg';
import './JTBDForm.css';

function JTBDForm({ onJobDefined, onClose }) {
  const [jobComponents, setJobComponents] = useState({
    actor: '',
    action: '',
    object: '',
    target: '',
    intention: ''
  });

  const handleInputChange = (field, value) => {
    setJobComponents(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const generateJobStatement = () => {
    const { actor, action, object, target, intention } = jobComponents;
    if (!actor || !action || !object || !target || !intention) {
      return '[Actor] wants to [action] [object] for [target] in order to [intention].';
    }
    return `${actor} wants to ${action} ${object} for ${target} in order to ${intention}.`;
  };

  const handleGenerateWorkbench = () => {
    const { actor, action, object, target, intention } = jobComponents;
    if (actor && action && object && target && intention) {
      onJobDefined({
        actor,
        action,
        object,
        target,
        intention,
        fullStatement: generateJobStatement()
      });
    }
  };

  const handleClose = () => {
    onClose();
  };

  const isFormComplete = Object.values(jobComponents).every(value => value.trim() !== '');

  return (
    <div className="form-overlay">
      <div className="form-modal">
        <button className="form-close-btn" onClick={handleClose}>
          ✕
        </button>

        <div className="form-header">
          <div className="header-icon">
            <img src={logo} alt="Workbench Logo" />
          </div>
          <h1 className="form-title">meos</h1>
          <p className="form-subtitle">Define your job to create a personalised AI-powered workbench.</p>
        </div>

        <div className="form-content">
          <div className="input-group">
            <label className="input-label">
              Actor <span className="input-hint">(Who?)</span>
            </label>
            <input
              type="text"
              className="form-input"
              placeholder="e.g., Marketing manager, Student, Entrepreneur..."
              value={jobComponents.actor}
              onChange={(e) => handleInputChange('actor', e.target.value)}
            />
          </div>

          <div className="input-group">
            <label className="input-label">
              Action <span className="input-hint">(What action?)</span>
            </label>
            <input
              type="text"
              className="form-input"
              placeholder="e.g., Create, Analyze, Research, Plan..."
              value={jobComponents.action}
              onChange={(e) => handleInputChange('action', e.target.value)}
            />
          </div>

          <div className="input-group">
            <label className="input-label">
              Object <span className="input-hint">(What thing?)</span>
            </label>
            <input
              type="text"
              className="form-input"
              placeholder="e.g., Marketing campaign, Business plan, Report..."
              value={jobComponents.object}
              onChange={(e) => handleInputChange('object', e.target.value)}
            />
          </div>

          <div className="input-group">
            <label className="input-label">
              Target <span className="input-hint">(For whom/what?)</span>
            </label>
            <input
              type="text"
              className="form-input"
              placeholder="e.g., B2B clients, University assignment, New product..."
              value={jobComponents.target}
              onChange={(e) => handleInputChange('target', e.target.value)}
            />
          </div>

          <div className="input-group">
            <label className="input-label">
              Intention <span className="input-hint">(Why/outcome?)</span>
            </label>
            <input
              type="text"
              className="form-input"
              placeholder="e.g., Increase conversions, Get better grade, Launch successfully..."
              value={jobComponents.intention}
              onChange={(e) => handleInputChange('intention', e.target.value)}
            />
          </div>

          <div className="job-preview">
            <label className="preview-label">Your Job Statement:</label>
            <div className="preview-box">
              {generateJobStatement()}
            </div>
          </div>

          <button
            className={`generate-btn ${isFormComplete ? 'active' : 'disabled'}`}
            onClick={handleGenerateWorkbench}
            disabled={!isFormComplete}
          >
            Setup My Workbench
          </button>
        </div>
      </div>
    </div>
  );
}

export default JTBDForm;